<template>
  <header
    class="relative z-50 flex justify-between items-center px-8 py-2 shadow-xl w-full mx-auto bg-white"
  >
    <div>
      <a href="/" class="block">
        <img
          src="~/assets/img/meditationcircle-logo.svg"
          alt="Logo"
          class="w-12 sm:w-16"
        />
      </a>
    </div>

    <!-- Desktop Menu -->
    <div class="flex items-center gap-4 text-brand-dark font-semibold">
      <ul class="flex gap-4">
        <li v-if="!currentUser"><a href="/login" class="cursor-pointer">Login</a></li>
        <li v-if="currentUser">
          <button @click="onLogoutClick" class="cursor-pointer">Logout</button>
        </li>
      </ul>
    </div>
  </header>
</template>

<script setup>
const currentUser = useSupabaseUser();

const client = useSupabaseClient();
const onLogoutClick = async () => {
  try {
    // form.pending = true;
    await client.auth.signOut();
    navigateTo("/login");
  } catch (error) {
    console.error("Error logging out:", error.message);
  } finally {
    form.pending = false;
  }
};
</script>

<style scoped></style>
